"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var React = __importStar(require("react"));
var style = renderer_1.StyleSheet.create({
    container: {
        position: "absolute",
        right: 0,
        left: 0,
        top: 0,
        height: 750,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transform: "rotate(20deg)",
    },
    text: {
        fontSize: 170,
        opacity: 0.2,
        fontWeight: 700,
    },
});
var DraftWatermark = function () { return (React.createElement(renderer_1.View, { style: style.container, fixed: true },
    React.createElement(renderer_1.Text, { style: style.text }, "DRAFT"))); };
exports.default = DraftWatermark;
//# sourceMappingURL=index.js.map